var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	"webpack/sharing/consume/default/@auth0/auth0-react/@auth0/auth0-react": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_auth0_auth0-react_2_24_1_react-dom_19_2_8_react_19_2_8__react_19_2_-aa7cb5").then(() => (() => (__webpack_require__(/*! @auth0/auth0-react */ "./node_modules/.pnpm/@auth0+auth0-react@2.24.1_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/@auth0/auth0-react/dist/auth0-react.esm.js"))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.24.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-react",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"src_bootstrap_tsx": [
		"webpack/sharing/consume/default/@auth0/auth0-react/@auth0/auth0-react"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}